import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/chendu.webp',
  './images/chendu1.webp',
  './images/chendu2.webp',
  './images/chendu3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Chengdu, the capital of Sichuan Province, is known for its laid-back lifestyle, spicy cuisine, and status as the home of the giant panda.

Top places to visit:

• Chengdu Research Base of Giant Panda Breeding – A world-famous conservation center for giant pandas.
• Wuhou Shrine – A memorial to Zhuge Liang, a legendary military strategist from the Three Kingdoms period.
• Jinli Ancient Street – A charming street full of traditional Sichuan snacks, souvenirs, and cultural performances.
• People's Park – A lively spot for tea drinking, dancing, and watching local life unfold.
• Mount Qingcheng – One of the birthplaces of Taoism with lush greenery and scenic hiking paths.
• Dujiangyan Irrigation System – An ancient engineering marvel that still functions today.
• Wide and Narrow Alleys (Kuanzhai Xiangzi) – A preserved area of Qing Dynasty-style courtyards and trendy shops.
• Sichuan Opera and Face-Changing Show – A must-see for its dazzling mask-swapping performance.
• Chunxi Road – Chengdu’s main shopping street, bustling with local and international brands.
• Jinsha Site Museum – An archaeological museum showcasing ancient Shu civilization.

Chengdu is a culinary paradise, famous for hotpot, mapo tofu, dandan noodles, and its UNESCO designation as a City of Gastronomy.`,

    zh: `成都是四川省省会，以悠闲的生活节奏、麻辣美食和大熊猫的故乡而著称。

推荐景点：

• 成都大熊猫繁育研究基地 – 世界著名的大熊猫保护中心，可近距离观看憨态可掬的熊猫。
• 武侯祠 – 纪念三国时期著名军事家诸葛亮的重要历史遗址。
• 锦里古街 – 融合传统与现代的古风街区，有川味小吃、手工艺品和表演。
• 人民公园 – 喝茶、相亲、跳舞，体验成都人惬意的生活方式。
• 青城山 – 道教圣地，环境清幽，适合登山与静心修行。
• 都江堰 – 被誉为“世界水利文化的鼻祖”的古代水利工程。
• 宽窄巷子 – 清代风貌的街区，集老成都韵味与时尚潮流于一体。
• 川剧变脸 – 四川传统戏剧表演，变脸技艺令人惊叹。
• 春熙路 – 成都市最繁华的商业街之一，购物、美食一应俱全。
• 金沙遗址博物馆 – 展示古蜀文明的重要考古发现。

成都是联合国教科文组织认定的“世界美食之都”，火锅、麻婆豆腐、担担面等美食令人垂涎。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/chendu.webp" className="travel-image2" />
          <img src="./images/chendu1.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Chengdu</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Chengdu</h2>
          <p className="carousel-subheading">
            Discover pandas, ancient Taoist culture, and the bold flavors of Sichuan cuisine.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc}  className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
